
import { useFormik } from 'formik';
import * as Yup from 'yup';
import CustomButton from '../../../../components/button';
import { IMAGES } from '../../../../../assets/images';

const SignIn = ({
    onPageUpdate,
    onFormSubmit,
    isLoader
}) => {
    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema: Yup.object({

            email: Yup.string()
                .email('Invalid email address')
                .required('Email Address is required'),
            password: Yup.string()
                .min(6, 'Password must be at least 6 characters')
                .required('Password is required'),
        }),
        onSubmit: (values) => {
            console.log('Form data:', values);
            onFormSubmit(values)
        },
    });



    return (

        <div>
            <div className='flex justify-center mb-5'>
                <img src={IMAGES.logo} alt="" className='w-[225px]' />
            </div>

            <h2 className="text-2xl font-bold mb-6 text-center">Login to your account</h2>
            <form onSubmit={formik.handleSubmit} className="space-y-4 w-[60%] mx-auto">

                {/* Email Address */}
                <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email Address *</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        className={`mt-1 block w-full p-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 ${formik.touched.email && formik.errors.email ? 'border-red-500' : 'border-gray-300'}`}
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                    {formik.touched.email && formik.errors.email && (
                        <p className="text-red-500 text-sm mt-1">{formik.errors.email}</p>
                    )}
                </div>

                {/* Password */}
                <div>
                    <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password *</label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        className={`mt-1 block w-full p-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 ${formik.touched.password && formik.errors.password ? 'border-red-500' : 'border-gray-300'}`}
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                    {formik.touched.password && formik.errors.password && (
                        <p className="text-red-500 text-sm mt-1">{formik.errors.password}</p>
                    )}
                    <div className='flex'>
                        <p className="mt-3 mb-1 text-sm text-left text-blue-500 hover:underline w-[50%]" onClick={() => onPageUpdate('mobile')}>
                            Login with OTP
                        </p>
                        <p className="mt-3 mb-1 text-sm text-right text-blue-500 hover:underline w-[50%]" onClick={() => onPageUpdate('forgotPassword')}>
                            Forgot Password?
                        </p>
                    </div>
                </div>
                <CustomButton title={'Login now'} type="submit" loader={isLoader} />
            </form>
            <p className="mt-4 text-center text-sm text-gray-600">
                Don't have an account? <span className="text-blue-500 hover:underline" onClick={() => onPageUpdate('signUp')}>Sign Up</span>
            </p>
        </div>
    )
}

export default SignIn